/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Discard_Keep_EditingInputs */

const cs_form_discard_keep_editing = /** @type {(inputs: Form_Discard_Keep_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat v úpravách`)
};

const en_form_discard_keep_editing = /** @type {(inputs: Form_Discard_Keep_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep editing`)
};

/**
* | output |
* | --- |
* | "Keep editing" |
*
* @param {Form_Discard_Keep_EditingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_discard_keep_editing = /** @type {((inputs?: Form_Discard_Keep_EditingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Discard_Keep_EditingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_discard_keep_editing(inputs)
	return cs_form_discard_keep_editing(inputs)
});